export default __webpack_public_path__ + "static/media/DharmaGothicE_ExLight_R.2959ed54.otf";